import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <div className="py-16 px-4 bg-gradient-to-r from-pink-600 to-purple-600">
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <h2 className="text-3xl lg:text-4xl font-bold text-white">
          Ready to ride?
        </h2>
        <p className="text-xl text-pink-100">
          Sign up now and get your first ride.
        </p>
        <Button
          onClick={() => navigate('/signup')}
          size="lg"
          className="bg-white text-pink-600 hover:bg-gray-100 font-semibold px-8 py-6 text-lg rounded-xl"
        >
          Get started
        </Button>
      </div>
    </div>
  );
};

export default CTASection;
